import Vue from 'vue'
import Router from 'vue-router'

/** 사전교육 패키지 관련 **/
import CodmosInfo from '@/components/CodmosInfo';
import CodmosMap from '@/components/CodmosMap';
import CodmosMission from '@/components/CodmosMission';
import CodmosAnalysis from '@/components/CodmosAnalysis';
import CodmosAnalysisDetail from '@/components/CodmosAnalysisDetail';

import CodingPartyMap from '@/components/CodingPartyMap';
import certificateTemplate from '@/components/map/MapPartialCertificate';

import CodmosMapNonLogin from '@/components/CodmosMapNonLogin';
import RunnerMap from '@/components/runner/Map';
import RunnerMapNonLogin from '@/components/runner/MapNonLogin';
import RunnerMapCodingParty from '@/components/runner/MapCodingParty';
import RunnerCertificateTemplate from '@/components/runner/MapPartialCertificate';

import JbMap from '@/components/jb/Map';
import JbMapCodingParty from '@/components/jb/MapCodingParty';
import JbCertificateTemplate from '@/components/jb/MapPartialCertificate';


Vue.use(Router);

const ROUTER = new Router({
  mode: 'history',
  routes: [
    /** 서버 기본 정보 학습 **/
    {
      path: '/codmos/info',
      name: 'CodmosInfo',
      component: CodmosInfo
    },
    /** 사전교육 패키지 리스트 **/
    {
      path: '/codmos/list',
      name: 'CodmosMap',
      component: CodmosMap,
      meta: {
        title: '이솦x코드모스 블록코딩미션'
      }
    },
    /** 사전교육 패키지 학습 **/
    {
      path: '/codmos/study/:id',
      name: 'CodmosMission',
      component: CodmosMission
    },
    /** 사전교육 패키지 학습 종합 결과(기본) */
    {
      path: '/codmos/analysis',
      name: 'CodmosAnalysis',
      component: CodmosAnalysis
    },
    /** 사전교육 패키지 학습 종합 결과(상세) */
    {
      path: '/codmos/analysis/detail',
      name: 'CodmosAnalysisDetail',
      component: CodmosAnalysisDetail
    },
    /** 코딩파티 **/
    {
      path: '/coding-party/list',
      name: 'CodingPartyMap',
      component: CodingPartyMap,
      meta: {
        title: '이솦x코드모스 온라인 코딩파티'
      }
    },
    {
      path: '/coding-party/runner',
      name: 'RunnerMapCodingParty',
      component: RunnerMapCodingParty,
      meta: {
        title: '이솦x코드모스 온라인 코딩파티'
      }
    },
    {
      path: '/coding-party/jeombak',
      name: 'JbMapCodingParty',
      component: JbMapCodingParty,
      meta: {
        title: '이솦x코드모스 온라인 코딩파티'
      }
    },
    /** 코딩파티 인증서 **/
    {
      path: '/codmos/certificate',
      name: 'certificateTemplate',
      component: certificateTemplate,
    },
    {
      path: '/codmos/runner/certificate',
      name: 'RunnerCertificateTemplate',
      component: RunnerCertificateTemplate,
    },
    {
      path: '/codmos/jb/certificate',
      name: 'JbCertificateTemplate',
      component: JbCertificateTemplate,
    },
    /** 러너 맵 **/
    {
      path: '/codmos/runner',
      name: 'RunnerMap',
      component: RunnerMap
    },
    /**  맵 **/
    {
      path: '/codmos/jeombak',
      name: 'JbMap',
      component: JbMap
    },

    // // 체험 계정용 링크
    // {
    //   path: '/codmos/trial/block',
    //   name: 'CodmosMapNonLogin',
    //   component: CodmosMapNonLogin
    // },
    // {
    //   path: '/codmos/trial/runner',
    //   name: 'RunnerMapNonLogin',
    //   component: RunnerMapNonLogin
    // },
    // CT 테스트
    {
      path: '/codmos/ct',
      name: 'CTMain',
      component: () => import('../components/CT/CTMain.vue')
    },
    {
      path: '/codmos/ct/play',
      name: 'CTPlay',
      component: () => import('../components/CT/CTPlay.vue')
    },
    {
      path: '/codmos/ct/result',
      name: 'CTResult',
      component: () => import('../components/CT/CTResult.vue')
    },
  ]
});

ROUTER.beforeEach((to, from, next) => {
  if (typeof to.meta.title !== 'undefined') document.title = to.meta.title;
  next();
});

export default ROUTER



// WEBPACK FOOTER //
// ./src/router/index.js